// gsap, ScrollTrigger, SplitText are globals from PHP-enqueued vendor scripts

let ctx;
let resizeListenerAdded = false;

function buildMaskedReveal(el) {
    if (el.__splitCleanup) {
        try { el.__splitCleanup(); } catch (e) {}
        el.__splitCleanup = null;
    }

    gsap.set(el, { autoAlpha: 0 });

    const split = new SplitText(el, {
        type: "lines",
        mask: "lines",
        linesClass: "line",
    });

    el.__splitCleanup = () => {
        try { split.revert(); } catch (e) {}
    };

    ScrollTrigger.create({
        trigger: el,
        start: "top 80%",
        once: true,
        onEnter: () => {
            gsap.set(el, { autoAlpha: 1 });
            gsap.fromTo(
                split.lines,
                { yPercent: 120, rotateX: 12, transformOrigin: "50% 100%" },
                {
                    yPercent: 0,
                    rotateX: 0,
                    ease: "osmo-ease",
                    duration: 0.5,
                    stagger: 0.1,
                    onComplete: () => gsap.set(split.lines, { clearProps: "transform" }),
                }
            );
        },
    });
}

export function splitText(container = document) {
    // Wait for fonts — SplitText needs accurate glyph metrics to break lines correctly
    const ready = document.fonts.ready.then(() => {
        if (ctx) ctx.revert();
        ctx = gsap.context(() => {
            container.querySelectorAll(".split-text").forEach(buildMaskedReveal);
        });
    });

    // Only attach the resize listener once; each call to splitText() rebuilds ctx
    if (!resizeListenerAdded) {
        resizeListenerAdded = true;
        let resizeTO;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTO);
            resizeTO = setTimeout(() => splitText(), 200);
        }, { passive: true });
    }

    return ready;
}
